import React, { Component } from 'react';
import { doubleConsentClose, doubleConsentShow, submitApplicationApi } from './TermsPageActions';
import _ from 'lodash';
import DoubleConsent from './DoubleConsent/DoubleConsent';
import PropTypes from 'prop-types';
import TermsAndConditions from './TermsAndConditions/TermsAndConditions';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { trackTransition, trackButtonAndLinkClick } from '../../../framework/store/FPTI/FPTIActions';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { FORM_ID, FLOW_TYPE, CREDIT_TYPE } from '../../../framework/App/AppConstants';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import '../../styles/base-us.less';
import NotificationBanner, { BANNER_STYLE, NOTIFICATION_TYPE } from '../../../shared-components/NotificationBanner/NotificationBanner';
import { PYMT_SECURITY_PAGE } from '../PaymentSecurityPage/PaymentSecurityPageConstants';

export class TermsPage extends Component {
    static propTypes = {
        creditType: PropTypes.string.isRequired,
        showDoubleConsent: PropTypes.bool.isRequired,
        email: PropTypes.string.isRequired,
        handleCancelTerms: PropTypes.func.isRequired,
        handleCancelDoubleConsent: PropTypes.func.isRequired,
        onAgreeDoubleConsent: PropTypes.func.isRequired,
        onCloseDoubleConsent: PropTypes.func.isRequired,
        onShowDoubleConsent: PropTypes.func.isRequired,
        formValues: PropTypes.object.isRequired,
        user: PropTypes.object,
        financingDetails: PropTypes.object,
        currentPage: PropTypes.string.isRequired,
        onClickX: PropTypes.func,
        flow: PropTypes.string.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        showPaymentSecurityToast: PropTypes.bool,
        hasPaymentSecurity: PropTypes.bool,
        onTogglePaymentSecurityToast: PropTypes.func
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleCancelTerms = event => {
        const { currentPage } = this.props;
        return this.props.handleCancelTerms(currentPage, event);
    };

    handleClickX = event => {
        const { currentPage } = this.props;
        return this.props.onClickX(currentPage, event);
    };

    onShowDoubleConsent = event => {
        const { currentPage } = this.props;
        return this.props.onShowDoubleConsent(currentPage, event);
    };

    handleCancelDoubleConsent = event => {
        return this.props.handleCancelDoubleConsent('doubleconsent', event);
    };

    onCloseDoubleConsent = event => {
        return this.props.onCloseDoubleConsent('doubleconsent', event);
    };

    onAgreeDoubleConsent = event => {
        const { formValues, hasPaymentSecurity = false } = this.props;
        event.preventDefault();
        return this.props.onAgreeDoubleConsent('doubleconsent', event, formValues, hasPaymentSecurity);
    };

    render() {
        const {
            showDoubleConsent,
            creditType,
            email,
            flow,
            showPaymentSecurityToast,
            onTogglePaymentSecurityToast
        } = this.props;
        return (
            <div className="outerWrapper us-wrapper">
                <div id="wrapper">
                    <div id="main">
                        {showPaymentSecurityToast && !showDoubleConsent && 
                            <NotificationBanner 
                                bannerStyle={BANNER_STYLE.DEFAULT}
                                type={NOTIFICATION_TYPE.CUSTOM}
                                useVX={false} 
                                message="You added Payment Security"
                                className="paymentSecurityAlert ppvx_alert"
                                iconClasses="paymentSecurityAlertIcon ppvx_icon ppvx_icon-check-circle-alt ppvx_icon--size_sm"
                                closeIconClasses="paymentSecurityCloseIcon"
                                isDismissable={true}
                                trackingToggle={onTogglePaymentSecurityToast}
                            />
                        }
                        {(flow !== FLOW_TYPE.TESLA) && (flow !== FLOW_TYPE.VENICE) && (
                            <Header
                                onCancel={this.handleClickX}
                                singleColumnLayout={true}
                            />
                        )}
                        <div id="content">
                            <div>
                                <TermsAndConditions
                                    onShowDoubleConsent={this.onShowDoubleConsent}
                                    handleCancel={this.handleCancelTerms}
                                    creditType={creditType}
                                    addAriaDescribedBy={showDoubleConsent}
                                />

                                {showDoubleConsent && (
                                    <DoubleConsent
                                        onHide={this.onCloseDoubleConsent}
                                        onAgree={this.onAgreeDoubleConsent}
                                        handleCancel={this.handleCancelDoubleConsent}
                                        email={email}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer showCancelUrl={flow !== FLOW_TYPE.TESLA} />
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const hasPaymentSecurity = _.get(state, 'serverData.enrollPymtSecurity', false);
    const isPaymentSecurityPageExperiment = _.get(state, 'serverData.elmo.PaymentSecurity') === PYMT_SECURITY_PAGE;

    return ({
        creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
        showDoubleConsent: state.showDoubleConsent,
        email: state.serverData.email,
        formValues: getFormValues(FORM_ID)(state) || {},
        currentPage: state.skeletonPage.currentPage,
        flow: _.get(state, 'serverData.flow'),
        showPaymentSecurityToast: isPaymentSecurityPageExperiment && hasPaymentSecurity,
        hasPaymentSecurity,
    });
};

export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onComponentDidMount() {
            dispatch(trackTransition('pp_credit_termspage', 'prepare_pp_credit_termspage'));
        },
        onTogglePaymentSecurityToast(visibleState) {
            const fptiVisibleState = visibleState.open ? 'open' : 'close';
            dispatch(trackTransition('pp_credit_termspage', `ppc_applctn_added_pmt_sec_toast_${fptiVisibleState}`));
        },
        handleCancelTerms(pageName, e) {
            dispatch(trackTransition('pp_credit_termspage', 'cancel_pp_credit_termspage'));
            // record click fpti client side tracking
            trackButtonAndLinkClick(e, pageName);
        },
        onClickX(pageName, e) {
            dispatch(trackTransition('pp_credit_termspage', 'cancel_x_pp_credit_termspage'));
            // record click fpti client side tracking
            trackButtonAndLinkClick(e, pageName);
        },
        onShowDoubleConsent(pageName, e) {
            dispatch(trackTransition('pp_credit_termspage', 'process_pp_credit_termspage'));
            dispatch(doubleConsentShow());
            dispatch(trackTransition(
                'pp_credit_apply_confirm',
                'prepare_apply_pp_credit_confirm'
            ));
            // record click fpti client side tracking
            trackButtonAndLinkClick(e, pageName);
        },
        handleCancelDoubleConsent(pageName, e) {
            dispatch(trackTransition('pp_credit_apply_confirm', 'cancel_apply_pp_credit_confirm'));
            // record click fpti client side tracking
            trackButtonAndLinkClick(e, pageName);
        },
        onCloseDoubleConsent(pageName, e) {
            dispatch(trackTransition('pp_credit_termspage', 'prepare_pp_credit_termspage', {
                event_action: 'close_credit_apply_confirm'
            }));
            dispatch(doubleConsentClose());
            // record click fpti client side tracking
            trackButtonAndLinkClick(e, pageName);
        },
        onAgreeDoubleConsent(pageName, event, formValues) {
            dispatch(spinnerOpen('base.submitApp'));
            dispatch(trackTransition(
                'pp_credit_apply_confirm_double_prompt',
                'prepare_apply_pp_credit_confirm_double_prompt'
            ));
            trackButtonAndLinkClick(event, pageName);
            return dispatch(submitApplicationApi(formValues));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsPage);
